import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';

export interface MenuComponentProps {
  onSelect: (drawerItem: string) => void;
  menuItemSelected?: string;
}

export interface DetailComponentProps {
  title?: string;
  handleBackSelection: () => void;
  item?: any;
  accessibilityCompliance?: boolean;
}

type DetailComponent =
  | React.FunctionComponent<DetailComponentProps>
  | React.ReactElement<DetailComponentProps>;

interface Props {
  Menu: React.ElementType<MenuComponentProps>;
  transitionStyles?: { [index: string]: string };
  detailItems: {
    [index: string]: DetailComponent;
  };
}

export const Drawer = ({ Menu, detailItems, transitionStyles }: Props) => {
  const [activeDrawerItem, setActiveDrawerItem] = useState<string>();

  const clearActiveDrawerItem = () => setActiveDrawerItem(undefined);

  return (
    <>
      <Menu menuItemSelected={activeDrawerItem} onSelect={setActiveDrawerItem} />
      <CSSTransition
        unmountOnExit
        in={Boolean(activeDrawerItem)}
        timeout={300}
        classNames={transitionStyles}
      >
        {() => {
          if (!activeDrawerItem) {
            return null;
          }
          const ActiveDrawerItemDetailComponent: DetailComponent =
            detailItems[activeDrawerItem];

          if (React.isValidElement(ActiveDrawerItemDetailComponent)) {
            return React.cloneElement(ActiveDrawerItemDetailComponent, {
              handleBackSelection: clearActiveDrawerItem,
            });
          }

          return (
            <ActiveDrawerItemDetailComponent
              handleBackSelection={clearActiveDrawerItem}
            />
          );
        }}
      </CSSTransition>
    </>
  );
};
